/* @flow */

export function requestParentUpdate(payload: Object): any {
  return {
    type: 'REQUEST_PARENT_UPDATE',
    payload
  };
}
